import { IAppState } from '../../../AppModulesWrapper';

export const selectSubagentSpendLimit = (state: IAppState): number => {
  return state.servicePickerWidget.user.limitedBalance || 0;
};
